<template>
  <a
    :href="link"
    target="_blank"
    rel="noopener"
    class="winners-2021-winner-item"
  >
    <Winners2021Stand :src="user.avatar" :alt="user.nickname" />
    <div class="winners-2021-winner-item__name orange">{{ user.nickname }}</div>
  </a>
</template>

<script>
import Winners2021Stand from "./Winners2021Stand";

export default {
  name: "Winners2021WinnerItem",
  components: {
    Winners2021Stand
  },
  props: {
    user: {
      type: Object,
      required: false
    }
  },
  computed: {
    link() {
      const { user } = this;
      return (
        (user &&
          user.steam_id64 &&
          `https://steamcommunity.com/profiles/${user.steam_id64}/`) ||
        null
      );
    }
  }
};
</script>

<style lang="scss">
.winners-2021-winner-item {
  display: flex;
  align-items: center;
  width: 100%;

  .winners-2021-stand {
    flex-shrink: 0;
    height: 66px;
    width: 88px;
    z-index: 1;
  }

  .winners-2021-stand-img {
    width: 49px;
    height: 49px;
    left: 20px;
    top: 10px;
  }

  &__name {
    font-weight: 800;
    padding: 10px 10px 10px 20px;
    font-size: 15px;
    background-color: #000a25;
    border-radius: 6px;
    text-align: left;
    flex-grow: 1;
    margin-left: -20px;
    min-width: 0;

    @include text-ellipsis();
  }
}
</style>
